export const Text = {
  home: {
    introText: {
      header: {
        norwegian: "Hjem",
        english: "Home",
      },
      text: {
        norwegian:
          "MarchFirst Norway AS er et investerings- og rådgivningsselskap som fokuserer på verdiskapning i tilknyttede selskaper og for utvalgte klienter.",
        english:
          "MarchFirst Norway AS is an investment and advisory company focusing on value creation in associated companies and for selected clients.",
      },
    },
  },
  services: {
    introText: {
      header: {
        norwegian: "Tjenester",
        english: "Services",
      },
      text: {
        norwegian:
          "Vår uavhengighet betyr at vi tilbyr upartisk og objektiv rådgivning for å maksimere verdiene for våre kunder.",
        english:
          "Our independence means that we offer impartial and objective advice to maximize the values for our customers.",
      },
    },
  },
  aboutUs: {
    introText: {
      header: {
        norwegian: "Om oss",
        english: "About",
      },
      text: {
        norwegian:
          "Vi i March First er et dedikert team med erfaring fra ulike selskaper, klare til å hjelpe deg. Ikke nøl med å ta kontakt hvis du ønsker å ta en uforpliktende prat!",
        english:
          "We at March First are a dedicated team with experience from various companies, ready to help you. Do not hesitate to contact us if you want to have a non-committal chat!",
      },
    },
    petter: {
      name: "Petter",
      norwegian: [
        "Petter har erfaring fra management consulting hos Arkwright. Deretter jobbet han som finansanalytiker i R.S. Platou Securities før han ledet Corporate Finance avdelingen til Enskilda Securities i Oslo. ",
        "Petter har jobbet med 200+ transaksjoner i de fleste bransjer og med selskaper i alle faser. ",
        "Petter har lang erfaring med styrearbeid og et meget stort nettverk som klienter nyter godt av. ",
      ],
      english: [
        "Petter has experience in management consulting at Arkwright. He then worked as a financial analyst at R.S. Platou Securities before leading the Corporate Finance department at Enskilda Securities in Oslo. ",
        "Petter has worked on 200+ transactions in various industries and with companies at all stages. ",
        "Petter has extensive experience in board work and a vast network that clients benefit from. ",
      ],
    },
    alex: {
      name: "Alex",
      norwegian: [
        "Alex har tidligere vært Head of Equities/ECM i Nordea Markets og Partner i First Securities (Swedbank). ",
        "Han har også jobbet med «workouts» i Danske Bank og finansielle og strategiske restruktureringer i Norden. ",
        "Alex har over 30 års erfaring fra M&A og utstedemarkedet i de fleste aktiva klasser og sektorer. Han har hatt ledende stillinger i New York og Oslo. ",
      ],
      english: [
        "Alex has previously been Head of Equities/ECM at Nordea Markets and a Partner at First Securities (Swedbank). ",
        "He has also worked with workouts at Danske Bank and financial and strategic restructuring in the Nordics. ",
        "Alex has over 30 years of experience in M&A and the issuance market in various asset classes and sectors. He has held senior positions in New York and Oslo. ",
      ],
    },
    introTop: {
      norwegian:
        "Marchfirst fortsetter å vokse og utvikle seg sammen med våre klienter, drevet av et engasjement for å skape varig verdi.",
      english:
        "Marchfirst continues to grow and evolve together with our clients, driven by a commitment to create lasting value.",
    },
    introBody: {
      norwegian:
        "Med et dedikert team på 6 eksperter har vi med suksess gjennomført over 50 transaksjoner som rådgiver og investor. Vår erfaring spenner over en bred rekke av SMB-bedrifter i ulike bransjer, noe som vitner om vår evne til å tilpasse oss og levere resultater på tvers av sektorer.",
      english:
        "With a dedicated team of 6 experts, we have successfully completed over 50 transactions as advisor and investor. Our experience spans a wide range of SME companies in various industries, which testifies to our ability to adapt and deliver results across sectors.",
    },
    values: {
      header: {
        norwegian: "Kjernen i Marchfirst er våre verdier:",
        english: "At the core of Marchfirst are our values:",
      },
      bullet1: {
        norwegian: "Integritet",
        english: "Integrity",
      },
      bullet2: {
        norwegian: "Grundighet",
        english: "Thoroughness",
      },
      bullet3: {
        norwegian: "Utholdenhet",
        english: "Perseverance",
      },
      text: {
        norwegian:
          "Disse verdiene gjenspeiles i alt vi gjør og er fundamentet for vår tilnærming til hver eneste oppgave og utfordring.",
        english:
          "These values are reflected in everything we do and are the foundation of our approach to every task and challenge.",
      },
    },
    history: {
      header: {
        norwegian: "Historien vår",
        english: "Our history",
      },
      body: {
        norwegian:
          "Marchfirst ble grunnlagt i 2003 av Petter Mannsverk Andresen og hans forretningspartner Christian Wessel. Siden starten har vi utviklet oss til å bli en ledende aktør innenfor våre kjerneområder: strategisk og finansiell analyse. Vi spesialiserer oss på Corporate Finance rådgivning og aktivt eierskap, og kombinerer disse feltene for å tilby våre klienter unike og verdiskapende løsninger. ",
        english:
          "Marchfirst was founded in 2003 by Petter Mannsverk Andresen and his business partner Christian Wessel. Since the start, we have developed into a leading player within our core areas: strategic and financial analysis. We specialize in Corporate Finance advisory and active ownership, and combine these fields to offer our clients unique and value-creating solutions. ",
      },
    },
    process: {
      intro: {
        header: {
          norwegian: "Vår prosess",
          english: "Our process",
        },
        text: {
          norwegian:
            "Vi spesialiserer oss på transaksjonsorienterte tjenester med fokus på industrielle løsninger for å maksimere verdi for våre klienter.",
          english:
            "We specialize in transaction-oriented services with a focus on industrial solutions to maximize value for our clients.",
        },
      },
      body: {
        norwegian:
          "Vår tilnærming er grundig, med dyptgående forståelse for kapitalmarkeder og klientbehov. Som uavhengige finansielle rådgivere prioriterer vi kvalitet, hastighet og konfidensialitet, samtidig som vi opprettholder tett dialog og leder prosjekter mot felles mål. Vårt arbeid bygger på integritet og empati, noe som har sikret oss et sterkt omdømme og gjentatte forretninger. Vi har tilgang til topp moderne databaser og nettverk for å støtte beslutningstaking. Vår uavhengighet sikrer konfliktfri rådgivning, og vi samarbeider med eksterne eksperter for å levere de beste løsningene. Suksess for våre klienter er vår suksess.",
        english:
          "Our approach is thorough, with in-depth understanding of capital markets and client needs. As independent financial advisors, we prioritize quality, speed and confidentiality, while maintaining close dialogue and leading projects towards common goals. Our work is based on integrity and empathy, which has secured us a strong reputation and repeated business. We have access to state-of-the-art databases and networks to support decision-making. Our independence ensures conflict-free advice, and we collaborate with external experts to deliver the best solutions. Success for our clients is our success.",
      },
    },
  },
  contact: {
    introText: {
      header: {
        norwegian: "Kontakt",
        english: "Contact",
      },
      text: {
        norwegian:
          "MarchFirst Norway AS er et investerings- og rådgivningsselskap som fokuserer på verdiskapning i tilknyttede selskaper og for utvalgte klienter.",
        english:
          "MarchFirst Norway AS is an investment and advisory company focusing on value creation in associated companies and for selected clients.",
      },
    },
  },
  projects: [
    {
      name: "Porterbuddy AS",
      year: "2022",
      description: {
        norwegian: "Salg av selskap til Instabox",
        english: "Sale of company to Instabox",
      },
      role: {
        norwegian: "Rådgiver til ledelsen",
        english: "Advisor to the board",
      },
    },
    {
      name: "Seljord Elektriske AS",
      year: "2022",
      description: {
        norwegian: "Salg av selskap til Byggmaker",
        english: "Sale of company to Byggmakker",
      },
      role: {
        norwegian: "Rådgiver til selgerne",
        english: "Advisor to the sellers",
      },
    },
    {
      name: "Lyngdal Byggeforretning AS",
      year: "2022",
      description: {
        norwegian: "Salg av selskap til Optimera",
        english: "Sale of company to Optimera",
      },
      role: {
        norwegian: "Rådgiver til selgerne",
        english: "Advisor to the sellers",
      },
    },
    {
      name: "Nytelse.no",
      year: "2021",
      description: {
        norwegian: "Salg av selskap til EQOM Group",
        english: "Sale of company to EQOM Group",
      },
      role: {
        norwegian: "Rådgiver til selgerne",
        english: "Advisor to the sellers",
      },
    },
    {
      name: "Martin Bruusgaard AS",
      year: "2020",
      description: {
        norwegian: "Salg av selskap til Addtech AB",
        english: "Sale of company to Addtech AB",
      },
      role: {
        norwegian: "Rådgiver til selger",
        english: "Advisor to seller",
      },
    },
    {
      name: "Farmforce AS",
      year: "2020",
      description: {
        norwegian: "Ny utstedelse av aksjer til institusjonelle investorer",
        english: "New issue of shares to institutional investors",
      },
      role: {
        norwegian: "Rådgiver til styret",
        english: "Advisor to the board",
      },
    },
    {
      name: "Sola Media AS",
      year: "2020",
      description: {
        norwegian: "Salg av selskap til Koch Films GmbH",
        english: "Sale of company to Koch Films GmbH",
      },
      role: {
        norwegian: "Rådgiver til selger",
        english: "Advisor to seller",
      },
    },
    {
      name: "Liv Norden AS",
      year: "2020",
      description: {
        norwegian: "Konvertibelt lån problem",
        english: "Convertible loan issue",
      },
      role: {
        norwegian: "Rådgiver til styret",
        english: "Advisor to the board",
      },
    },
    {
      name: "Playsafe Holding AS",
      year: "2020",
      description: {
        norwegian: "Fairness opinion ang. bud fra Playsafe Group AS",
        english: "Fairness opinion re. bid from Playsafe Group AS",
      },
      role: {
        norwegian: "Rådgiver til styret",
        english: "Advisor to the board",
      },
    },
    {
      name: "Bember AS",
      year: "2020",
      description: {
        norwegian: "Konvertibelt lån problem",
        english: "Convertible loan issue",
      },
      role: {
        norwegian: "Rådgiver til styret",
        english: "Advisor to the board",
      },
    },
    {
      name: "Porterbuddy AS",
      year: "2019",
      description: {
        norwegian: "Ny utstedelse av aksjer til strategiske investorer",
        english: "New issue of shares to strategic investors",
      },
      role: {
        norwegian: "Rådgiver til styret",
        english: "Advisor to the board",
      },
    },
    {
      name: "Tideforsikring",
      year: "2019",
      description: {
        norwegian: "Konvertibelt lån problem",
        english: "Convertible loan issue",
      },
      role: {
        norwegian: "Rådgiver til styret",
        english: "Advisor to the board",
      },
    },
    {
      name: "Parklink by Bember",
      year: "2019",
      description: {
        norwegian:
          "Rådgiver til styret i forbindelse med 25 MNOK ny utstedelse av aksjer",
        english:
          "Advisor to board in connection with 25 MNOK new issue of shares",
      },
      role: {
        norwegian: "Rådgiver til styret",
        english: "Advisor to the board",
      },
    },
    {
      name: "Hove Medical Systems",
      year: "2018",
      description: {
        norwegian:
          "Rådgiver for selger av minoritetsandel i Hove Medical Systems AS til Patientsky AS",
        english:
          "Advisor to seller of minority shareholding in Hove Medical Systems AS to Patientsky AS",
      },
      role: {
        norwegian: "Rådgiver til selger",
        english: "Advisor to seller",
      },
    },
    {
      name: "Lycro",
      year: "2018",
      description: {
        norwegian:
          "Rådgiver til Lycro i forbindelse med 10 millioner NOK egenkapitalutstedelse",
        english:
          "Advisor to Lycro in connection with NOK 10 mill equity issue.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
    {
      name: "Prosess AS",
      year: "2018",
      description: {
        norwegian: "Strategisk og finansiell rådgiver til Prosessor.",
        english: "Strategic and financial advisor to Prosessor.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
    {
      name: "Prosess AS",
      year: "2018",
      description: {
        norwegian:
          "Rådgiver til Prosessor i forbindelse med 10 MNOK egenkapitalutstedelse.",
        english:
          "Advisor to Prosessor in connection with NOK 10 mill equity issue.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
    {
      name: "Skaar Omsorg AS",
      year: "2017",
      description: {
        norwegian:
          "Rådgiver til Skaar Omsorg AS i forbindelse med kjøpet av Frogner Sykehjem.",
        english:
          "Advisor to Skaar Omsorg AS in connection with purchase of Frogner Sykehjem.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
    {
      name: "Skaar Omsorg AS",
      year: "2017",
      description: {
        norwegian:
          "Rådgiver til Skaar Omsorg AS i forbindelse med kjøpet av Linjerud AS.",
        english:
          "Advisor to Skaar Omsorg AS in connection with purchase of Linjerud AS.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
    {
      name: "Kravia AS",
      year: "2017",
      description: {
        norwegian:
          "Rådgiver til Kravia i forbindelse med oppkjøpet av Akros AS, Norsk Inkasso AS & Bonitet AS.",
        english:
          "Advisor to Kravia in connection with the acquisitions of Akros AS, Norsk Inkasso AS & Bonitet AS.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
    {
      name: "Combiwood",
      year: "2017",
      description: {
        norwegian:
          "Rådgiver for selger av flertallsandel i Baros AS til Combiwood.",
        english:
          "Advisor to seller of majority shareholding in Baros AS to Combiwood.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
    {
      name: "Myhre Heis",
      year: "2017",
      description: {
        norwegian:
          "Rådgiver for selger i forbindelse med salg av Myhre heis til Orona.",
        english:
          "Advisor to seller in connection with sale of Myhre heis to Orona.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
    {
      name: "Geilo Taubane AS",
      year: "2017",
      description: {
        norwegian: "Salg av Geilo Taubane AS.",
        english: "Sale of Geilo Taubane AS.",
      },
      role: {
        norwegian: "Rådgiver",
        english: "Advisor",
      },
    },
  ],
};
